export default __webpack_public_path__ + "static/media/EESymbolsImg4.cbcfc313.jpg";